import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "indicator-card__values" }
const _hoisted_2 = { class: "indicator-card__value" }
const _hoisted_3 = { class: "indicator-card__value-measure" }
const _hoisted_4 = { class: "indicator-card__percent" }
const _hoisted_5 = {
  key: 0,
  class: "margin-5"
}
const _hoisted_6 = {
  key: 0,
  class: "fas fa-solid text-green fa-arrow-up arrow"
}
const _hoisted_7 = {
  key: 1,
  class: "fas fa-solid text-red fa-arrow-down arrow"
}
const _hoisted_8 = {
  key: 2,
  class: "indicator-card__year"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['indicator-card', _ctx.mod ? `indicator-card--${_ctx.mod}` : '']),
    style: _normalizeStyle(_ctx.cardStyle),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCardClick && _ctx.handleCardClick(...args)))
  }, [
    _renderSlot(_ctx.$slots, "title", {}, () => [
      _createElementVNode("div", {
        class: _normalizeClass({ 'indicator-card__title-wrapper': _ctx.tooltipText })
      }, [
        _createElementVNode("p", {
          class: "indicator-card__title",
          style: _normalizeStyle(_ctx.titleStyle)
        }, _toDisplayString(_ctx.title), 5),
        (_ctx.tooltipText)
          ? (_openBlock(), _createBlock(_component_Tooltip, {
              key: 0,
              triggers: ['click'],
              modContent: _ctx.modContentTooltip,
              class: "ml-30"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "tooltipContent", {}, () => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tooltipText), 1)
                ])
              ]),
              _: 3
            }, 8, ["modContent"]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _renderSlot(_ctx.$slots, "values", {}, () => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.resolveValueFormat), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.valueMeasure ?? ''), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.place)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.place) + " место", 1))
            : (_ctx.percentValue)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass([_ctx.percentDirection, "margin-5"])
                }, [
                  (_ctx.percentValue > 0)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                    : (_openBlock(), _createElementBlock("i", _hoisted_7)),
                  _createTextVNode(_toDisplayString(_ctx.resolvePercentValue), 1)
                ], 2))
              : _createCommentVNode("", true),
          (_ctx.year)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.year), 1),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, " г.", -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 6))
}